import React from 'react';
import { useAuth } from '../context/AuthContext';
import LoginPage from '../pages/Login/LoginPage';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, initializing } = useAuth();

  // Show loading spinner while checking auth
  if (initializing) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-spinner">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Render children if authenticated
  return children;
}